import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['progress'];
  progressTarget: any;

  connect() {
    console.log('Progress controller connected');
  }

  updateText(text: string) {
    this.progressTarget.textContent = text;
  }

  update(ev: CustomEvent) {
    this.progressTarget.textContent = ev.detail;
  }
}
